import {produce} from 'immer';
import Link from '@swiss-ski/sski-entity-types/src/topic/Link';
import * as applicationActionTypes from './applicationActionTypes';
import {ERROR} from '../utils/ftemConstants';

/**
 * Initial application domain state
 *
 * @type {Object}
 */
const initialState = {
    serviceManager: null,
    links: [],
    sportId: null,
    feedback: null,
};

/**
 * Application reducer
 *
 * @param state
 * @param action
 * @returns {Object}
 */
const applicationReducer = produce((draft, action) => {
    switch (action.type) {
        case applicationActionTypes.STORE_LINKS: {
            const {links, linksPrev} = action.payload;
            const createLinks = links.map(link => new Link().fromDTO(link));
            if (linksPrev) {
                createLinks.push(...linksPrev);
            }
            draft.links = createLinks;
            break;
        }
        case applicationActionTypes.SET_SPORT_ID: {
            const {getSportId} = action.payload;
            draft.sportId = getSportId;
            break;
        }
        case applicationActionTypes.SEND_FEEDBACK_REQUEST_FAILED:
        case applicationActionTypes.SEND_FEEDBACK_ERROR: {
            draft.feedbackError = ERROR;
            break;
        }
        case applicationActionTypes.RESET_FEEDBACK: {
            draft.feedback = null;
            draft.feedbackError = null;
            break;
        }
        case applicationActionTypes.SEND_FEEDBACK_REQUEST_SUCCEEDED:
        case applicationActionTypes.STORE_FEEDBACK_RESPONSE:
        {
            draft.feedback = true;
            break;
        }
        default:
        // no-op
    }
}, initialState);

export default applicationReducer;
